import React from 'react'
import { connect } from 'react-redux'
import VerifyModal from 'shared/components/VerifyModal/VerifyModal.jsx'

const Hoc =
  (WrappedComponent) =>
  ({ isVerified, ...props }) => {
    if (isVerified === false) {
      window.toggleVerifyModal && window.toggleVerifyModal(true)
      return <VerifyModal />
    }
    return <WrappedComponent {...props} />
  }

export default (HocComponent) =>
  connect((state) => {
    const user = state.auth.get('user')
    const isVerified = user && user.get('isVerified')

    return {
      isVerified,
    }
  })(Hoc(HocComponent))



// WEBPACK FOOTER //
// ./js/shared/providers/withVerifyCheck.jsx